/**
 * Resolves paths under `public/` so assets load from any route (e.g. `/login`)
 * and when the app is hosted under a subpath (`PUBLIC_URL`).
 */
export function publicAsset(relativePath: string): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const path = relativePath.replace(/^\/+/, "");
  return `${base}/${path}`;
}
